import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-card-thumb-1.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-card-thumb-2.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-card-thumb-3.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-shape-2-1.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-shape-2-2.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/feature/feature-shape-2-3.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/hero/bitcoin.svg");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/normal/cta_3-1.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/normal/intro_1-1.png");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/assets/img/update/normal/why_1-1.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/component/homes/home-one/RoadMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/component/homes/home-two/Brand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/component/homes/home-two/CtaArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/component/homes/home-two/FaqArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/component/homes/home-two/Testimonia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/layouts/footers/FooterTwo.tsx");
